(function () {
  'use strict';
  /* ONE VIEWER, EVERY GALLERY (2026-09-11).
     The resin and bundle galleries were the only two that could be enlarged;
     the tools, the oils and the jade/rose/sanctum pages were on a different
     gallery each and none of them zoomed (Sho: "there's still not a
     standardisation between the flow of images ... I can't seem to zoom into
     the image like I can with the resin"). Rather than a fourth and fifth
     gallery player, the contract families now all resolve to this one:
       data-r45-main / data-r45-thumb        resins   (product-hero-r45)
       data-ffr13-main / data-ffr13-thumb    bundles  (product-first-flame-r13)
       data-r45o-main / data-r45o-thumb      the oils (product-myrrh-oil-r45)
       data-pdp-main / data-pdp-thumb        everyone else, via [data-pdp-photo]
     The last two families are additive: the two originals are untouched, so
     their behaviour cannot drift. */
  var dialog = document.querySelector('[data-gallery-dialog]');
  var main = document.querySelector('[data-r45-main], [data-ffr13-main], [data-r45o-main], [data-pdp-main]');
  var photo = main && main.closest('.r45-photo-main, .ffr13-photo-main, .r45o-photo, [data-pdp-photo]');
  if (!dialog || !photo || typeof dialog.showModal !== 'function') return;
  var thumbs = Array.from(document.querySelectorAll('[data-r45-thumb], [data-ffr13-thumb], [data-r45o-thumb], [data-pdp-thumb]'));
  var script = document.currentScript;
  // The photograph is the door. It is announced as a button and reachable by keyboard,
  // and nothing is drawn over it.
  photo.classList.add('ss-gallery-ready');
  main.setAttribute('role', 'button');
  main.setAttribute('tabindex', '0');
  // The alt stays the photo's name; the action is its description.
  var hint = document.createElement('span');
  hint.id = 'ss-gallery-open-hint';
  hint.hidden = true;
  hint.textContent = (script && script.getAttribute('data-gallery-open-label')) || 'Enlarge image';
  photo.appendChild(hint);
  main.setAttribute('aria-describedby', hint.id);
  var image = dialog.querySelector('[data-gallery-image]');
  var viewport = dialog.querySelector('[data-gallery-viewport]');
  var counter = dialog.querySelector('[data-gallery-position]');
  var prev = dialog.querySelector('[data-gallery-prev]');
  var next = dialog.querySelector('[data-gallery-next]');
  var zoom = dialog.querySelector('[data-gallery-magnify]');
  var error = dialog.querySelector('[data-gallery-error]');
  var close = dialog.querySelector('[data-gallery-close]');
  var index = 0, zoomed = false, revision = 0, oldOverflow = '';
  function magnify(value) {
    zoomed = value;
    zoom.setAttribute('aria-pressed', String(value));
    viewport.classList.toggle('is-zoomed', value);
    if (value) {
      // Land at the centre of the enlarged photograph, not its top-left corner.
      viewport.scrollLeft = (viewport.scrollWidth - viewport.clientWidth) / 2;
      viewport.scrollTop = (viewport.scrollHeight - viewport.clientHeight) / 2;
    } else {
      viewport.scrollTop = viewport.scrollLeft = 0;
    }
  }
  function show(i, sync) {
    index = Math.max(0, Math.min(Math.max(0, thumbs.length - 1), i));
    magnify(false); error.hidden = true;
    var thumb = thumbs[index];
    var url = thumb ? thumb.getAttribute('data-full') : main.currentSrc || main.src;
    image.alt = thumb ? thumb.getAttribute('data-full-alt') || main.alt : main.alt;
    var generation = ++revision;
    /* Never open on an empty frame. The viewer used to set opacity:0 (.is-loading),
       start a fresh download of the larger data-full file, and fade in on load —
       so every open began with a blank stage (2026-09-11, Sho: "everytime the
       image starts from a flash"). The pixels the shopper is already looking at
       are decoded and in cache, so paint those immediately and upgrade to the
       full-resolution file silently once it has arrived. */
    var instant = (thumb && thumb.querySelector('img') && thumb.querySelector('img').currentSrc) ||
                  main.currentSrc || main.src;
    if (image.src !== url) {
      if (instant && image.src !== instant) image.src = instant;
      image.classList.remove('is-loading');
      var upgrade = new Image();
      upgrade.onload = function () {
        if (generation !== revision) return;
        image.src = url;
      };
      upgrade.onerror = function () {
        if (generation !== revision) return;
        /* No full-resolution file: the cached frame above stays on screen, which
           is a better failure than an empty stage plus an error panel. Only say
           so when there is nothing at all to show. */
        if (!image.naturalWidth) error.hidden = false;
      };
      upgrade.src = url;
    } else {
      image.classList.remove('is-loading');
    }
    counter.textContent = (index + 1) + ' / ' + (thumbs.length || 1);
    var focused = document.activeElement;
    prev.disabled = index === 0; next.disabled = index >= thumbs.length - 1;
    // At either end the arrow you stand on goes away; keep focus inside the viewer.
    if (focused === prev && prev.disabled) (next.disabled ? close : next).focus();
    if (focused === next && next.disabled) (prev.disabled ? close : prev).focus();
    if (sync && thumb) thumb.click();
    image.onload = function () { if (generation === revision) image.classList.remove('is-loading'); };
    image.onerror = function () {
      /* Only a failure of the frame actually on screen is worth reporting; the
         full-resolution upgrade has its own handler above. */
      if (generation === revision && !image.naturalWidth) { image.classList.remove('is-loading'); error.hidden = false; }
    };
    if (image.complete && image.naturalWidth) image.classList.remove('is-loading');
  }
  function open(source) {
    if (dialog.open) return;
    /* aria-current is the resin/bundle contract; the pdp-gallery rails (jade,
       rose, inner sanctum) mark the live frame with a class instead. Accept
       both, or the viewer would open on image 1 while the rail says 3. */
    var current = thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true' || t.classList.contains('active'); });
    show(current < 0 ? 0 : current, false);
    oldOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    try {
      document.dispatchEvent(new CustomEvent('sacrasoul:behavior', {detail: {name: 'gallery_opened',
        properties: {source: source || 'photo', index: index + 1, total: thumbs.length || 1, family: photo.classList.contains('ffr13-photo-main') ? 'bundle' : 'resin'}}}));
    } catch (e) {}
  }
  // A scroll/swipe on the original image must never turn into an enlargement.
  var start = null, moved = false;
  photo.addEventListener('touchstart', function (e) {
    moved = e.touches.length !== 1;
    start = e.touches.length === 1 ? {x:e.touches[0].clientX,y:e.touches[0].clientY} : null;
  }, {passive:true});
  photo.addEventListener('touchmove', function (e) {
    if (!start || e.touches.length !== 1) { moved = true; return; }
    if (Math.abs(e.touches[0].clientX-start.x)>10 || Math.abs(e.touches[0].clientY-start.y)>10) moved=true;
  }, {passive:true});
  main.addEventListener('click', function () { if (!moved) open('photo'); moved=false; });
  main.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open('keyboard'); }
  });
  close.addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('close', function () {
    document.body.style.overflow = oldOverflow;
    magnify(false); revision++;
    if (main.isConnected) main.focus({preventScroll:true});
  });
  prev.addEventListener('click', function () { show(index-1,true); });
  next.addEventListener('click', function () { show(index+1,true); });
  zoom.addEventListener('click', function () { magnify(!zoomed); });
  dialog.addEventListener('keydown', function (e) {
    if (zoomed) return;
    if (e.key==='ArrowLeft') { e.preventDefault(); show(index-1,true); }
    if (e.key==='ArrowRight') { e.preventDefault(); show(index+1,true); }
  });
  // Inside the viewer a tap on the photograph toggles the close look; a swipe turns the page.
  var touch = null, dragged = false;
  viewport.addEventListener('touchstart', function (e) {
    dragged = e.touches.length !== 1;
    touch = e.touches.length===1 ? {x:e.touches[0].clientX,y:e.touches[0].clientY} : null;
  }, {passive:true});
  viewport.addEventListener('touchmove', function (e) {
    if (!touch || e.touches.length !== 1) { dragged = true; return; }
    if (Math.abs(e.touches[0].clientX-touch.x)>10 || Math.abs(e.touches[0].clientY-touch.y)>10) dragged=true;
  }, {passive:true});
  viewport.addEventListener('touchend', function (e) {
    if (!touch) return;
    var dx=e.changedTouches[0].clientX-touch.x,dy=e.changedTouches[0].clientY-touch.y;touch=null;
    if(!zoomed && Math.abs(dx)>42 && Math.abs(dx)>Math.abs(dy)*1.4) { show(index+(dx<0?1:-1),true); dragged = true; }
  }, {passive:true});
  image.addEventListener('click', function () { if (!dragged) magnify(!zoomed); dragged = false; });
})();
